import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isDesktop } from 'react-device-detect';
import { selectDeeplinkToken, selectDeeplinkUrl, selectDeeplinkQR, selectEmail } from '../signup/signupSlice';
import { selectEventsData } from '../events/eventsSlice';
import { sendAnalyticsEvents } from '../../analytics/common'
import { EVENTS as E } from '../../analytics/events';
import UIButton from '../../UI/UIButton'
import * as S from './styled';

const APP_ONE_LINK = 'https://fml.onelink.me/3cUC/bnhyu1g7';
const getCustomDeeplink = (token)=> {
  return `${APP_ONE_LINK}?deep_link_value=${token}`;
};

const Success = ({ screenId = '' }) => {
  const { t } = useTranslation();
  const eventsData = useSelector(selectEventsData);
  const email = decodeURIComponent(useSelector(selectEmail) || '');
  const deeplinkToken = useSelector(selectDeeplinkToken);
  const deepLinkUrl = useSelector(selectDeeplinkUrl) || getCustomDeeplink(deeplinkToken);
  const deepLinkQR = useSelector(selectDeeplinkQR);
  const [eventSent, setEventSent] = useState(false);
  const [openQR, setOpenQR] = useState(false);

  const onContinueClick = () => {
    if (!deepLinkUrl) return;
    sendAnalyticsEvents(E.onboardingDone, eventsData);
    window.location.href = deepLinkUrl;
  };

  const handleOpenQr = () => {
    if (!deepLinkQR) return;
    setOpenQR(!openQR);
  };

  useEffect(() => {
    if (eventSent) return;
    setTimeout(() => sendAnalyticsEvents(E.onboardingSuccessShown, eventsData), 1000);
    setEventSent(true);
  }, [eventSent, eventsData]);

  return (
    <>
      <S.HeaderWrapper>
        <S.Logo />
        <S.Text>Familo</S.Text>
      </S.HeaderWrapper>
      <S.SuccessWrapper>
        <S.TitleWrapper>
          <S.Title>{t('your_plans_awaits')} 🎉</S.Title>
          <S.Subtitle>{t(`download_app_via_${isDesktop ? 'qr' : 'button'}`)}</S.Subtitle>
        </S.TitleWrapper>
        <S.InstructionsTitle>{t('follow_these_steps')}</S.InstructionsTitle>
        <S.InstructionsWrapper>
          <S.ItemRow>
            <div>
              <div dangerouslySetInnerHTML={{ __html: t('tap_on_login_screen') }} />
              <S.Screenshot>
                <S.ScreenshotButton>{t('continue')}</S.ScreenshotButton>
                <S.ScreenshotHighlight>{t('i_have_an_account')}</S.ScreenshotHighlight>
              </S.Screenshot>
            </div>
          </S.ItemRow>
          <S.ItemRow>
            <div dangerouslySetInnerHTML={{ __html: t('sign_in_with', { email }) }} />
          </S.ItemRow>
          {/*<S.ItemRow>
            <div>{t('your_password_sent')}</div>
          </S.ItemRow>*/}
        </S.InstructionsWrapper>
        <S.CheersTitle>{t('enjoy_using')}</S.CheersTitle>
        <S.CheersText>{t('dont_need_to_pay')}</S.CheersText>
        {isDesktop && (
					<S.DesktopQR>
						<S.QRCode
							id={'qrcode'}
							onClick={handleOpenQr}
							$open={openQR}
							title={t(openQR ? '' : 'click_to_enlarge')}
							$img={deepLinkQR}
						></S.QRCode>
						<span>{t('scan_qr_code')}</span>
					</S.DesktopQR>
				)}
       <UIButton
					customId={'success-button'}
					onClick={onContinueClick}
					disabled={!deepLinkUrl}
				>
					{t('download_app')}
        </UIButton>
        <input type='hidden' id='end-of-onboarding' />
      </S.SuccessWrapper>
    </>
  );
};

export default Success;
